<template>
  <div>
    <v-alert
      icon="mdi-emoticon-sick-outline"
      class="mb-2"
      dense
      text
      type="warning"
      v-if="!isHoliday && now && diff > 0"
    >
      <!-- v-if="$can('all_permissions')" -->
      <v-row align="center">
        <v-col class="grow">
          I am feeling sick today! Apply for sick leave within
          {{ twoDigits(hours) + ':' + twoDigits(minutes) + ':' + twoDigits(seconds) }}
          <div>If there is any issue applying, please contact 9792929</div>
          <div>Requests in "draft" status are not considered applied</div>
        </v-col>
        <v-col class="shrink">
          <v-btn x-small @click="$refs.sickRequestModal.open()">Apply</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-alert
      icon="mdi-crowd"
      class="mb-2"
      dense
      text
      type="info"
      v-if="now && diff > 0"
    >
      <v-row align="center">
        <v-col class="grow">
          Apply for FRL within
          {{ twoDigits(hours) + ':' + twoDigits(minutes) + ':' + twoDigits(seconds) }}
        </v-col>
        <v-col class="shrink">
          <v-btn x-small @click="$refs.frlRequestModal.open()">Apply</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-if="uncertifiedLeaves.has_uncertified_leaves"
      icon="mdi-file-document"
      dense
      text
      type="info"
      class="mb-2"
    >
      <v-row align="center">
        <v-col class="grow">
          Uncertified sick leave in past days.
        </v-col>
        <v-col class="shrink">
          <v-btn x-small @click="$refs.leaveDocumentModal.open(User.staff.ISMID)">submit documents</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <LeaveRequestModal ref="frlRequestModal" :leave_type="3" />
    <LeaveRequestModal ref="sickRequestModal" :leave_type="6" />

    <leave-document-modal ref="leaveDocumentModal" />
  </div>
</template>

<script>
import LeaveDocumentModal from '../leaves/LeaveDocumentModal.vue'
import LeaveRequestModal from '../leaves/LeaveRequestModalNew.vue'

export default {
  components: {
    LeaveRequestModal,
    LeaveDocumentModal,
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },

    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },

    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
  },
  watch: {
    now(value) {
      this.diff = this.deadline - value
      if (this.diff <= 0) {
        this.diff = 0
        if (this.nowinterval) clearInterval(this.nowinterval)
      }
    },
  },
  data: () => ({
    now: null,
    deadline: null,
    diff: 0,
    nowinterval: null,
    timestamp: null,
    isHoliday: true,
    uncertifiedLeaves: {}
  }),
  methods: {
    hasUncertifiedLeaves() {
      this.$axios.get(`/api/leave-documents/hasUncertifiedLeaves`).then((resp) => {
        this.uncertifiedLeaves = resp.data
      })
    },
    twoDigits(value) {
      return value.toString().padStart(2, '0')
    },
  },
  async created() {
    this.$axios.get(`/api/timestamp`).then(res => {
      this.timestamp = parseInt(res.data.timestamp + '000')
      this.isHoliday = res.data.isHoliday

      // set deadline
      //let { h, m } = this.User.is_prosecutor ? { h: 8, m: 30 } : { h: 9, m: 0 }
      let { h, m } = res.data.sickDue
      let dl = new Date(this.timestamp)
      dl.setHours(h)
      dl.setMinutes(m)
      dl.setSeconds(0)
      this.deadline = Math.trunc(dl.getTime() / 1000)
      this.now = Math.trunc(new Date(this.timestamp).getTime() / 1000)

      this.nowinterval = setInterval(() => this.now++, 1000)
    })

    this.hasUncertifiedLeaves()
  },
  destroyed() {
    if (this.nowinterval) clearInterval(this.nowinterval)
  },
}
</script>
